<template>
  <v-app class="player">
    <!-- [ ] TODO CLEAN: Refactor the logic how we handle displaying the snackbar in the player. -->
    <v-snackbar
      :auto-height="snackbar.autoHeight"
      :top="true"
      :right="true"
      :color="snackbar.color"
      :multi-line="mobile"
      :timeout="snackbar.timeout"
      v-model="snackbar.enabled"
      :id="{'user-action-snackbar': ['change-user', 'login'].includes(snackbar.action)}"
      :class="snackbar.class"
      role="alert"
      aria-describedby="snackbar-text-content"
    >
    <div id="snackbar-text-content" style='width: 100%' :class="{'text-xs-center': user && user.is_lti}" role="alert" aria-live="assertive" :style="`color: ${snackbar.textColor}`">
      {{snackbar.text}}
    </div>
    <v-progress-circular v-if="snackbar.spinner" indeterminate  color="white" :size="18" :width="2"></v-progress-circular>
    <div v-if="snackbar.action || snackbar.bluescreen" class="snackbar-actions">
      <v-btn :color="snackbar.textColor" flat @click="redirectToLogin()" v-if="showLoginButtonAction">
        {{(snackbar.action === 'change-user') ? 'Not you?' : 'Login'}}
      </v-btn>
      <v-btn v-if="snackbar.bluescreen" :color="snackbar.textColor" flat @click='newBlueScreenRedirect(snackbar.bluescreen)'>
        More Info
      </v-btn>
      <v-btn v-if="snackbar.action === 'sync'" :color="snackbar.textColor" flat @click="syncLtiGrade">
        Sync
      </v-btn>
      <v-btn v-if="snackbar.action === 'playbackMode' && !isBroadcast" :color="snackbar.textColor" flat @click="openSettingsMenu">
        Toggle Playback Mode
      </v-btn>
      <v-btn v-if="snackbar.action === 'youTubeBlocked'" :color="snackbar.textColor" flat @click="launchKbArticle">
        More Info
      </v-btn>
      <template v-if="snackbar.action === 'fullscreen'">
        <v-btn  :color="snackbar.textColor" flat @click="fullscreen">
          Expand
        </v-btn>
      </template>
      <template v-if="snackbar.action === 'resume'">
        <v-btn  :color="snackbar.textColor" flat @click="resume">
          Resume
        </v-btn>
        <v-btn :color="snackbar.textColor" flat @click="snackbar.enabled = false;">
          No
        </v-btn>
      </template>
      <v-btn v-if="snackbar.action === 'panoptoHelpArticle'" :color="snackbar.textColor" flat @click="redirectToPanoptoHelpArticle">
        Not working?
      </v-btn>
      <template v-if="snackbar.action === 'internetSpeedTest'">
        <v-btn
          :color="snackbar.textColor"
          flat
          @click="checkInternetSpeed()">
            Check internet speed
        </v-btn>
        <v-btn
          :color="snackbar.textColor"
          flat
          @click="snackbar.enabled = false;">
            Close
        </v-btn>
      </template>
      <v-btn v-else v-show="!snackbar.excludeOk" class="close" :color="snackbar.textColor" flat @click="snackbar.enabled = false;">
        OK
      </v-btn>
    </div>
    </v-snackbar>
    <div v-show='!loaded || !videosPrepped' class="player-loader grey darken-4">
      <v-progress-circular indeterminate :size="70" :width="5" style='color:#f9f9f9' ></v-progress-circular>
    </div>
    <div id="posit-embed-wrapper" v-if="loaded" v-show='videosPrepped'>
      <div id="posit-player" style="height:100%; overflow:hidden;">
        <bulb-controls ref='bulbControls'></bulb-controls>
      </div>
    </div>
    <v-dialog v-if="showWarpwireModal" v-model="showWarpwireModal" max-width="600px" :fullscreen="mobile">
      <v-card style="min-height: 300px">
        <iframe :src="warpwireRedirect" width="100%" height="300px"></iframe>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="showNameModal"
      :class="{
        'remove-onfocus-show-name-modal-embedded': (showNameModal && isVideoInstanceEmbeddedInIframe)
      }"
      v-model="showNameModal"
      ref="showNameModal"
      :fullscreen="mobile"
      persistent
      :lazy="true"
      max-width="600px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md class="pa-0">
            <v-layout wrap>
                <v-flex xs12 class="pa-2">
                <span class="headline">Please type your name:</span>
                </v-flex>
                <v-flex xs12 :class="[computedGridLayout]">
                  <v-text-field 
                  label="First Name"
                  placeholder="First Name"
                  v-model="newUser.firstName"
                  @input="$v.newUser.firstName.$touch()"
                  @blur="$v.newUser.firstName.$touch()"
                  required
                  :error-messages="firstNameErrors">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 :class="[computedGridLayout]">
                  <v-text-field 
                  label="Last Name"
                  placeholder="Last Name"
                  v-model="newUser.lastName"
                  @input="$v.newUser.lastName.$touch()"
                  @blur="$v.newUser.lastName.$touch()"
                  required
                  :error-messages="lastNameErrors">
                  </v-text-field>
                </v-flex>
                <span style="margin: 38px -2px;" v-if="schoolHasTitleDropdown && !mobile">,</span>
                <v-flex xs12 sm4 v-if="schoolHasTitleDropdown">
                  <v-text-field 
                  v-model="newUser.title"
                  label="Title"
                  placeholder="Title"
                  :disabled="disableUserTitle"
                  @input="$v.newUser.title.$touch()"
                  @blur="$v.newUser.title.$touch()"
                  required
                  :error-messages="titleErrors">
                  </v-text-field>
                  <v-checkbox
                  v-model="disableUserTitle"
                  class="pa-0 ma-0"
                  label="Omit title"
                  color="primary">
                  </v-checkbox>
                </v-flex>
                <v-flex>
                  <p class="mb-0">You are attempting as: {{computedUsersNameAndTitle}}</p>
                </v-flex>
                <v-flex xs12 class="text-xs-right">
                  <v-btn color="primary" :disabled="!canSubmitStudentName" :loading="processingNameModal" @click.native="updateUser" class="ma-0">Save</v-btn>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-if="showCopyBulbModal" v-model="showCopyBulbModal" content-class="copy-bulb">
      <v-card elevation="0">
        <v-list class="branding-active pa-0">
          <v-list-tile avatar>
            <v-responsive :aspect-ratio="16/9" max-height="36px" max-width="64px" style="margin-right: 20px;">
              <div class="thumbnail-wrapper-nonselect" :style="bulbThumbnail"></div>
            </v-responsive>
            <v-list-tile-content>
              <v-list-tile-title>
                <h3 class="white--text">Copy {{ termForBulb.capitalize() }}</h3>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-card elevation="0">
          <v-card-title>
            <div style="width: 100%">
              <h3 class="py-4 ">Would you like to create a copy of {{bulb.name}}?</h3>
              <div>
                <form style="width: 100%">
                  <v-text-field
                    class="full-width"
                    v-model="bulbCopyName"
                    :label="`Copied ${termForBulb.capitalize()} Name`"
                    :placeholder="bulbCopyName"
                  ></v-text-field>
                  <!--:error-messages="formErrors('copy')"-->
                </form>
              </div>
            </div>
          </v-card-title>
          <v-card-actions class="row-space px-3" justify-space-between>
            <v-flex>
              <v-btn flat class="branded-grey" @click="setShowCopyBulbModal(false)">Cancel</v-btn>
            </v-flex>
            <v-flex class="text-xs-right">
              <!-- :disabled="formErrors('copy').length > 0"-->
              <v-btn @click="copyBulb({bulb_id: bulb.id, name: bulbCopyName, edit: true})" :disabled="!bulbCopyName.length || copyingBulb" flat text class="primary--text">Copy & Edit</v-btn>
              <!-- " :disabled="formErrors('copy').length > 0" -->
              <v-btn @click="copyBulb({bulb_id: bulb.id, name: bulbCopyName, edit: false})" :disabled="!bulbCopyName.length || copyingBulb" text color="primary" class="text-white">Copy Only</v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="showMigrationNoticeModal"
      v-model="showMigrationNoticeModal"
      max-width="600px"
    >
      <v-card elevation="0">
        <v-list class="branding-active pa-0">
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-icon color="white">info</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <h3 class="white--text">Migration Notice</h3>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-card-text>
          <p>
            This link is no longer active, please log into <a href="https://www.wevideo.com">https://www.wevideo.com</a> to access your account or ask your instructor for a new assign link.
          </p>
        </v-card-text>
        <v-card-actions class="row-space px-3" justify-space-between>
          <v-flex class="text-xs-right">
            <v-btn flat class="branded-grey" @click="showMigrationNoticeModal = false">Confirm</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div
      v-if="showPanoptoAuthIframe"
      class="full-height authentication-iframe-wrapper panopto"
      @mouseover="panoptoIframeMouseOver = true"
      @mouseout="panoptoIframeMouseOver = false">
      <iframe
        aria-label="Panopto iFrame"
        ref="panoptoIframe"
        class="clickable"
        :src="panoptoAuthIframeSrc">
      </iframe>
    </div>
    <PlaypositOffline :readyToInject="loaded && videosPrepped"/>
  </v-app>
</template>

<script>
/* eslint-disable */
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex';

import {
  required,
  maxLength
} from 'vuelidate/lib/validators';

import {
  calculateContrast,
  getInheritedBackgroundColor,
} from '@utilities';

// Custom Components:
import BulbControls from '@/components/BulbControls';
import EventBus from '@/buses/EventBus';

// Services:
import PlayerService from '@/services/PlayerService';
import XApiService from '@/services/XApiService';

// Global Mixin(s):
import Toast from '@mixins/Toast/Toast.js';

// Helpers:
import { validateEmail } from '@/js/helpers.js';
import { triggerLearnerStatus } from '@/js/firestore-utils';

import {
  UPDATE_FAV_ICON_SCHOOLS,
} from '@Constants';

// Externals:
import _ from 'lodash';
window.lodash = _;
import 'ua-parser-js'
import Color from 'color';
import cssVars from 'css-vars-ponyfill';
const parser = require('ua-parser-js');
const store = require('store');

// VideoJS - All plugins/techs must be loaded AFTER the main videojs package.
import injectYoutubePlayerApi from 'videojs-youtube';
require('videojs-iframe');
require('videojs-panopto');
require('videojs-vimeo');
require('videojs-hotkeys');
require('videojs-vhs-logger');
require('videojs-contrib-quality-levels');
require('video.js-css');

export default {
  name: 'player',
  components: {
    BulbControls,
  },
  data() {
    return {
      chosenInteractions: null,
      loaded: false,
      loadError: false,
      newUser: {
        firstName: "",
        lastName: "",
        title: '',
      },
      disableUserTitle: false,
      controlsWrapperTabTimeout: null,
      processingNameModal: false,
      showNameModal: false,
      showWarpwireModal: false,
      token: null,
      tokenType: null,
      tutorial: false,
      wasHidden: false,
      warpwireRedirect: false,
      showPanoptoAuthIframe: false,
      showMigrationNoticeModal: false,
      panoptoAuthNeeded: false,
      panoptoAuthIframeSrc: null,
      panoptoIframeMouseOver: false,
      hostedIframeSource: `${this.$getServerUrl()}hosted/index.html`,
    }
  },
  mixins: [ Toast ],
  computed: {
    ...mapGetters('adaptive', [
      'adaptive_bulb',
    ]),
    ...mapGetters('player', [
      'branding',
      'bulb',
      'bulbAttempt',
      'bulbInitialized',
      'copyingBulb',
      'displayDuration',
      'isBroadcast',
      'isPlaylist',
      'mobile',
      'playerState',
      'queryParams',
      'schoolId',
      'snackbar',
      'user',
      'sidebarOpen',
      'sidezoneOpen',
      'user',
      'userAgent',
      'isBroadcastStudent',
      'broadcastId',
      'hasPlayerContinuePlaybackOnWindowUnloadFeature',
      'termForBulb',
      'termForBulbArticle',
      'shouldUseYoutubeEducationPlayer',
    ]),
    ...mapState('player', [
      'isLiveSession',
      'liveSessionStartTime',
      'playerControlsDisplayType',
      'playbackModeType',
      'sessionId',
      'studentSubmissionId',
      'unixBulbEndTime',
      'panoptoEmbedInitializationError',
      'isVideoInstanceEmbeddedInIframe',
      'bulbIsPD',
    ]),
    videosPrepped() {
      /**
       * DUCTTAPE MOBILE/YOUTUBE - Youtube videos on mobile won't play if the metadata isn't loaded before the first
       * time initialize_play() is clicked. The computed tracks whether or not the videos are
       * a) loaded and b) have the metadata loaded. Otherwise it shows the loading spinner.
       */
      if (this.loaded) {
        return _.filter(this.bulb.bulbVideos,(b) => (b.metadataInitialized)).length === this.bulb.bulbVideos.length;
      }
      return false;
    },
    bulbCopyName: {
      get() {
        return this.$store.getters['player/bulbCopyName'];
      },
      set(val) {
        this.setBulbCopyName(val)
      }
    },
    bulbThumbnail() {
      return {
        backgroundImage: `url("${this.bulb.thumbnail}")`
      }
    },
    computedGridLayout() {
      return this.schoolHasTitleDropdown ? 'sm4' : 'sm6';
    },
    computedUsersNameAndTitle() {
      return (this.newUser.firstName || this.newUser.lastName || this.newUser.title) 
      ? `${this.newUser.firstName} ${this.newUser.lastName}${(this.newUser.title && !this.disableUserTitle) ? ',' : ''} ${(!this.disableUserTitle) ? this.newUser.title : ''}` : '';
    },
    firstNameErrors () {
      const errors = [];
      if (!this.$v.newUser.firstName.$dirty) return errors;
      !this.$v.newUser.firstName.maxLength && errors.push('First name must be at most 25 characters long');
      !this.$v.newUser.firstName.required && errors.push('First name is required.');
      !this.$v.newUser.firstName.excluded && errors.push('First name cannot contain punctuation');
      return errors;
    },
    lastNameErrors () {
      const errors = [];
      if (!this.$v.newUser.lastName.$dirty) return errors;
      !this.$v.newUser.lastName.maxLength && errors.push('Last name must be at most 25 characters long');
      !this.$v.newUser.lastName.required && errors.push('Last name is required.');
      !this.$v.newUser.lastName.excluded && !this.isKaiserSchool && errors.push('Last name cannot contain punctuation');
      return errors;
    },
    titleErrors() {
      if (!this.disableUserTitle) {
        const errors = [];
        if (!this.$v.newUser.title.$dirty) return errors;
        !this.$v.newUser.title.maxLength && errors.push('Title name must be at most 30 characters long.');
        !this.$v.newUser.title.required && errors.push('Title is required.');
        !this.$v.newUser.title.excluded && errors.push('Title can only have spaces, commas, numbers, or periods.');
        return errors;
      }
    },
    canSubmitStudentName() {
      if (_.has(this.newUser, 'firstName')) {
        if (this.schoolHasTitleDropdown) {
          let canSubmit = (
            this.newUser.firstName !== ''
            && this.newUser.lastName !== ''
            && this.newUser.firstName.toLowerCase() !== 'firstname'
            && this.newUser.lastName.toLowerCase() !== 'lastname'
            && !this.$v.newUser.firstName.$anyError
          );
          return (this.disableUserTitle) ? canSubmit : (canSubmit && this.newUser.title !== '' && !this.$v.newUser.title.$anyError);
        }
        return (
          this.newUser.firstName !== ''
          && this.newUser.lastName !== ''
          && this.newUser.firstName.toLowerCase() !== 'firstname'
          && this.newUser.lastName.toLowerCase() !== 'lastname'
          && !this.$v.newUser.$anyError
        );
      }
      return false;
    },
    section() {
      return _.find(this.bulb.sections, { id: this.bulbAttempt.sectionId});
    },
    showCopyBulbModal: {
      get() {
        const show =  this.$store.getters['player/showCopyBulbModal'];
        if (show) EventBus.$emit('requestAction', 'pause');
        return show;
      },
      set(val) {
        this.setShowCopyBulbModal(val);
      }
    },
    showLoginButtonAction() {
      if (_.get(this, 'bulb.teachers[0].school.config.permissions', []).includes('barbriStyle')) return false;
      if (['change-user', 'login'].includes(this.snackbar.action)) return true;
      return false;
    },
    schoolHasTitleDropdown() {
      return _.get(this, 'bulb.teachers[0].school.config.permissions', []).includes('hasListCodeTitleDropdown');
    },
    isKaiserSchool() {
      return [1759, 2045, 2046, 2047, 2053, 2601].includes(_.get(this.bulb, 'masterTeacher.school.id'));
    },
    // [ ] Potentially create a mixin to house this logic, that both the Designer and Player could just import.
    handlePanoptoAuthenticationFlow() {
      window.addEventListener('message', (e) => {
        if (e.origin.includes('panopto') && _.get(e, 'data')) {
          const panoptoPlayerIframeData = JSON.parse(e.data);
          if (panoptoPlayerIframeData.msg === 'iframeLoginShown') this.panoptoAuthNeeded = true;
          if (this.panoptoAuthNeeded && panoptoPlayerIframeData.msg === 'embedIframeReady') {
            // At this point, the user has successfully logged in and the 'embedIframeReady' event has been fired from the Panopto embed logic
            this.fireToast({
              icon: 'success',
              iconColor: this.$vuetify.theme.primary,
              title: 'Refreshing current session...',
              customClass: {
                title: 'playposit-player-toast'
              },
              willClose: () => {
                location.reload();
              }
            });
          }
        }
      });
    },
    firstBulbVideoUtilizesVimeoEmbedPlayer() {
      return this.bulb.bulbVideos[0].bulbVideoStreams[0].type === 'vimeo';
    },
  },
  validations: {
    newUser:{
      firstName: {
        required,
        maxLength: maxLength(25),
        excluded: n => !(/[<>.,\/#!$%\^&\*;:{}=\?_`~()]/g.test(n)) // prevent adding scripts tags, commas, question marks, and semicolons
      },
      lastName: {
        required,
        maxLength: maxLength(25),
        excluded: n => !(/[<>.,\/#!$%\^&\*;:{}=\?_`~()]/g.test(n)) // prevent adding scripts tags, commas, question marks, and semicolons,
      },
      title: {
        required,
        maxLength: maxLength(30),
        excluded: n => !(/[-'"<>\\\/#!$%\^&\*;:\|{}=+\?_`~()\\[\]]/g.test(n)) // prevent adding scripts tags, and any meta character.
      },
    }
  },
  methods: {
    ...mapMutations('adaptive', [
      'setBulbComplexity',
  		'setComplexityLevels',
  		'setSegmentComplexity',
  		'setTreatment',
  	]),
  	...mapMutations('player', [
  	  'setBulb',
      'setBulbIsPD',
  	  'setBroadcastBulbDefaults',
  	  'setDisplayTimeStart',
  	  'setBulbAttempt',
      'setIsBroadcast',
      'setIsListcode',
      'setIsLiveSession',
  	  'setShowCopyBulbModal',
  	  'setBulbCopyName',
  	  'setLmsLaunch',
  	  'setUser',
  	  'setUserAgent',
  	  'setQueryParams',
  	  'setSettingsMenu',
  	  'setSnackbar',
  	  'setSidebarOpen',
  	  'setSidezoneOpen',
      'setThirdPartyCookiesEnabled',
  	  'setIsBroadcastStudent',
  	  'setIsBroadcastTeacher',
  	  'setStudentSubmissionId',
      'setYoutubeVr',
      'triggerFallbackStream',
      'updatePqOrigin',
      'updateProquestVideoUrl',
      'updatePpWrapper',
      'setLti13Launch',
      'setLMSIssuer',
      'updateYoutubePlayerConfiguration',
    ]),
    ...mapActions('interactions', [
      'constructInitialInteractionStates',
    ]),
    ...mapActions('player', [
      'copyBulb',
      'setupLiveSessionData',
      'syncLocalUnixTime',
      'syncLtiGrade',
    ]),
    launchKbArticle() {
      window.open('https://knowledge.playposit.com/article/216-troubleshooting-bulb-playback#blockedvideo')
    },
    redirectToLogin() {
      store.clearAll();
      window.location = 'https://www.playposit.com/login';
    },
    addCSS(styleArray) {
      const node = document.createElement('style');
      styleArray.forEach((el, i) => node.innerHTML = el);
      document.body.appendChild(node);
    },
    blueScreenRedirect(props) {
      const msg = `msg=${encodeURI(props.msg)}` || '';
      const primary_text = props.primary_text ? `&primary_text=${encodeURI(props.primary_text)}` : '';
      const primary_link = props.primary_link ? `&primary_link=${encodeURIComponent(props.primary_link)}` : '';
      const secondary_text = props.secondary_text ? `&secondary_text=${encodeURI(props.secondary_text)}` : '';
      const secondary_link = props.secondary_link ? `&secondary_link=${encodeURIComponent(props.secondary_link)}` : '';
      const noButtons = props.noButtons ? `&nobuttons=${props.noButtons}` : '';
      const blueScreen = `https://www.playposit.com/msg?${msg}${primary_text}${primary_link}${secondary_text}${secondary_link}${noButtons}`
      dataLayer.errorLog({message:JSON.stringify({bluescreen:props})}, this.$options.name);
      window.location = blueScreen;
    },
    checkIfAnonymous() {
      const anonRegex = /useranonymous[0-9]+.[0-9]+/;
      const noNameRegex = /firstnamelastname[0-9]+.[0-9]+/;
      if (anonRegex.test(this.user.email) || noNameRegex.test(this.user.email)) {
        this.setIsListcode(true);
      }
    },
    newBlueScreenRedirect(props) {
      props.sessionId = _.isNil(this.sessionId) ? 101 : this.sessionId;
      this.$enablePlaypositErrorScreen({
          vertical: true,
          active_color: this.$vuetify.theme.primary,
          base_color: this.$vuetify.theme.secondary,
          inactive_color: this.$vuetify.theme.tertiary,
          title: _.has(props, 'title') ? props.title : 'Error',
          subtitle: _.has(props, 'subtitle') ? props.subtitle : 'Sorry, something has gone wrong.',
          code: _.isNil(this.sessionId) ? 101 : this.sessionId,
          text: _.has(props, 'text') ? props.text : '',
          icon: _.has(props, 'icon') ? props.icon : 'error',
          buttons: _.has(props, 'buttons') ? props.buttons : [],
        });
      dataLayer.errorLog(props);
    },
    bluescreenUnsupportedBrowser() {
      if ((this.userAgent.browser.name === 'IE' || this.userAgent.browser.name === 'IEMobile') ) {
        const props = {};
        // if there is a token, append it to the copy link
        const copyLink = _.has(this.user, 'token') ? `${window.location.href}&token=${this.user.token}` : window.location.href;
        // look up teachers to see if their main school or school.masterDistrict is part of Kaiser
        const isKaiser = _.reduce(this.bulb.teachers, (isKaiser, t) =>  isKaiser || (_.get(t, 'school.id') === 1759 || _.get(t, 'school.masterDistrict') === 1759), false);
        if (isKaiser) {
          props.title = 'Please open in Chrome';
          props.text = `
              <div>1. Internet Explorer is not a supported</div>
              <div>2. Click the "COPY LINK" button below</div>
              <div>3. Open Google Chrome (or Mozilla Firefox, Microsoft Edge, Apple Safari)</div>
              <div>4. Paste the link into the address bar and press "enter"</div>
            `
        } else {
          props.title = 'Unsupported Browser';
          props.text = 'This browser version is not supported. Try again on another browser (<a href="https://www.google.com/chrome/browser/" target="_blank">Chrome recommended</a>).';
        }
        // check for Kaiser and schools as of 2/26/2020 that have Kaiser as a master district
        this.$enablePlaypositErrorScreen({
          title: props.title,
          text: `${props.text}<input style="position:absolute; left:-1000px; top:-1000px" id="playerReloadUrl" value="${copyLink}">`, // append copy link for
          buttons: [
            { text: 'Close', action: 'back',  order: 1 },
            {
              text: 'Copy Link',
  						action: () => {
                navigator.clipboard.writeText(copyLink);
  						},
  						order: 0
            }
          ]
        });
      }
    },
    // [ ] Consider moving this the the setBulb function Ã°Å¸Â« 
    formatInteractionBanks() {
      const filteredInteractions = [];
      for (const [index, bank] of this.bulb.banks.entries()) {
        if (bank.type === 'random') {
          if (bank.interactions.length > 0) { // handle empty question banks
            const numberOfInteractions = bank.interactions.length;
            let randomInteractionIndex;
            if (this.queryParams.get('type') === 'share') randomInteractionIndex = _.random(0, numberOfInteractions - 1);
            else if (this.queryParams.get('type') ==='broadcast') randomInteractionIndex = _.get(this.bulb, 'teachers[0].id', 0) % numberOfInteractions;
            else randomInteractionIndex = this.bulbAttempt.id % numberOfInteractions;
            const chosenInteractionId = bank.interactions[randomInteractionIndex].id;
            // bulbBank has correct interaction options - overwrite interactions from random banks with correct data
            const selectedInteractionIndex = _.findIndex(this.bulb.interactions, { 'id': chosenInteractionId })
            this.bulb.interactions[selectedInteractionIndex].position = bank.bulbBank.position;
            if (_.get(bank, 'bulbBank.config')) this.bulb.interactions[selectedInteractionIndex].config = {...bank.bulbBank.config};
            this.bulb.interactions[selectedInteractionIndex].pause = bank.bulbBank.isPause;
            this.bulb.interactions[selectedInteractionIndex].retake = bank.bulbBank.isRetake;
            this.bulb.interactions[selectedInteractionIndex].attempts = bank.bulbBank.attempts;
            this.bulb.interactions[selectedInteractionIndex].autograde = bank.bulbBank.isAutograde;
            this.bulb.interactions[selectedInteractionIndex].rewind = bank.bulbBank.isRewind;
            if (this.user.userType !== 'teacher') this.bulb.interactions[selectedInteractionIndex].isRequired = !bank.bulbBank.isOptional;
            this.bulb.interactions[selectedInteractionIndex].random = bank.bulbBank.isRandom;
            if (!_.isNil(bank.bulbBank.jumpCorrect)) this.bulb.interactions[selectedInteractionIndex].jumpCorrect = bank.bulbBank.jumpCorrect;
            if (!_.isNil(bank.bulbBank.jumpIncorrect)) this.bulb.interactions[selectedInteractionIndex].jumpIncorrect = bank.bulbBank.jumpIncorrect;
            this.bulb.interactions[selectedInteractionIndex].displayInTime = bank.bulbBank.displayInTime + (index / 10000);
            this.bulb.interactions[selectedInteractionIndex].displayOutTime = bank.bulbBank.displayOutTime + (index / 10000);
            for (const interaction of bank.interactions) {
              if (interaction.id !== chosenInteractionId) {
                filteredInteractions.push(interaction.id);
              }
            }
          }
        } else {
          for (const interaction of bank.interactions) {
            if (_.get(interaction, 'config.live_session_only') && !this.isLiveSession) continue;
            const interactionIndex = _.findIndex(this.bulb.interactions, { 'id': interaction.id });
            this.bulb.interactions[interactionIndex].displayInTime = (
              bank.bulbBank.displayInTime + (index / 10000) + (interaction.interactionBank.order / 100000)
            );
            this.bulb.interactions[interactionIndex].displayOutTime = (
              bank.bulbBank.displayOutTime + (index / 10000) + (interaction.interactionBank.order / 100000)
            );
            // Extra logic to handle Vimeo embed player zeroth interaction issues:
            if (
              this.firstBulbVideoUtilizesVimeoEmbedPlayer
              && interaction.displayInTime <= 0.9
              && ( // Allows ToC interactions to still be durational in Vimeo videos
                interaction.type !== 'pause_q'
                && !interaction.interactionText.includes('data-toc-interaction')
              )
            ) {
              this.bulb.interactions[interactionIndex].displayInTime = 0;
              this.bulb.interactions[interactionIndex].displayOutTime = 0;
            }
          }
        }
      }
      this.chosenInteractions = _.filter(this.bulb.interactions, (i) => !filteredInteractions.includes(i.id))
    },
    fullscreen() {
      this.$refs.bulbControls.$refs.settings.fullScreen();
      this.snackbar.enabled = false;
    },
    async getInitialBulbData() {

      const type = this.queryParams.get('type');
      const pqOrigin = this.queryParams.get('pqorigin');
      const ppWrapper = this.queryParams.get('ppWrapper');
      const proquestVideoUrl = this.queryParams.get('proquest_video_url');
      if (type === 'broadcast') this.setIsBroadcast(true);
      if (pqOrigin) this.updatePqOrigin(pqOrigin);
      if (ppWrapper) this.updatePpWrapper(ppWrapper);
      if (proquestVideoUrl) this.updateProquestVideoUrl(proquestVideoUrl);
      if (store.get('skip-panopto-authorization')) store.remove('skip-panopto-authorization');
      const query = {
        bulb_id: this.queryParams.get('bulb_id'),
        section_id: this.queryParams.get('section_id'),
        student_id: this.queryParams.get('observer'),
        resource_link_id: this.determineResourceLinkId(),
        lti13Launch: this.queryParams.get('lti13Launch'),
        render_path: this.queryParams.get('render_path') ? this.queryParams.get('render_path') : '',
        playlist_id: this.queryParams.get('playlist_id') ? this.queryParams.get('playlist_id') : '',
        module_id: this.queryParams.get('module_id') ? this.queryParams.get('module_id') : '',
      };
      const { data: { migrated } } = await PlayerService.getBulbOwnerMigrationStatus(query.bulb_id);
      if (
        migrated
        && type !== 'share'
      ) {
        return this.newBlueScreenRedirect({
          title: 'Migration Notice',
          subtitle: 'This link is no longer active.',
          icon: 'pan_tool',
          text: 'Please log into <a class="white--text" href="https://www.wevideo.com">https://www.wevideo.com</a> to access your account or ask your instructor for a new assign link.',
        });
      }

      // [ ] figure out vue router this.$route.params.type, this.$route.query
      PlayerService.getInitialBulbData(type, query).then(async (res) => {
        this.updateYoutubePlayerConfiguration(res.data.youtubePlayerConfiguration);
        if (res.data.bulb.lmbId === 1) this.handleInitialPlayerDataFailure('rootLmbPreview');
        if (res.data.bulb.bulbVideos.length === 0 && res.data.bulb.lmbId !== 1) this.handleInitialPlayerDataFailure('missingBulbVideos');
        const school = res.data.bulb.teachers[0].school;
        if (
          !_.isEmpty(school)
          && school?.permissionKeys?.includes('enableDirectPlayerCssInjection')
          && school.cssInjectionContent?.length
        ) {
          this.loadCssInjectionDirectly(school.cssInjectionContent);
        } else if (
          !_.isEmpty(school)
          && school?.cssInjection?.length
        ) {
          this.loadCssInjection(school.cssInjection);
        }
        this.setUser(res.data.user);
        if (this.isBroadcast) {
          this.setBulb(res.data.bulb);
          this.setBroadcastBulbDefaults();
        }
        else this.setBulb(res.data.bulb);
        injectYoutubePlayerApi({
          shouldUseYoutubeEducationPlayer: this.shouldUseYoutubeEducationPlayer,
        });
        if (
          type === 'bulb'
          && query.bulb_id
          && query.section_id
          && this.bulb.teachers[0].migrated
        ) {
          this.showMigrationNoticeModal = true;
        }
        if (UPDATE_FAV_ICON_SCHOOLS.includes(_.get(res, 'data.bulb.masterTeacher.school.id', []))) this.updateFaviconAndTitle();
        this.bluescreenUnsupportedBrowser() // must be called after setBulb to ensure that schoolId is generated
        this.setBulbAttempt(res.data.bulbAttempt);
        if (_.get(res, 'data.bulbAttempt.isNew')) {
          // Only fire event if bulbAttempt was created, not if it already existed.
          const { data: bulbAttempt } = await PlayerService.sendProquestBulbAttemptUpdate({
            bulbAttemptId: res.data.bulbAttempt.id,
            event: 'create',
          });
          if (
            bulbAttempt?.id
            && window.self !== window.top
          ) {
            window.parent.postMessage(JSON.stringify({
              type: 'bulbAttempt',
              event: 'create',
              data: _.omit(bulbAttempt, ['bulb']),
            }), '*');
          }
        }
        // Set isLiveSession
        if (
          _.get(this.bulb, 'sections[0].bulbSection.sessionStartTime', false)
          && this.user.userType === 'student'
        ) {
          this.syncLocalUnixTime();
          this.setIsLiveSession(true);
        }
        this.formatInteractionBanks();
        this.constructInitialInteractionStates({
          interactions: _.sortBy(this.chosenInteractions, 'displayInTime'),
          interactionAttempts: res.data.bulbAttempt.interactionAttempts
        });
        if (this.isLiveSession) {
          this.setupLiveSessionData();
        }
        // [ ] error handling for missing data
        this.$nextTick(() => {
          dataLayer.push({
            'ouruser_id': this.user.id,
            'ouruser_type': this.user.userType,
            'ouruser_email': this.user.email,
            'ouruser_name': this.user.firstName + ' ' + this.user.lastName,
            'ouruser_lessons': this.bulb.id,
          })
          this.setBranding(this.branding);
          this.setupXAPI(res.data);
          this.setPlayerUserType();
          this.checkIfAnonymous();
          this.userSnackbar();
          this.setupPanoptoEvents();
          this.loaded = true;

          // -- if broadcast initialize init panel
          if (type === 'broadcast') {
            if (this.user && this.user.userType === 'teacher') this.setIsBroadcastTeacher(true);
            else if (this.user && this.user.userType === 'student') this.setIsBroadcastStudent(true);
            this.setSidezoneOpen(true);
        		this.setSidebarOpen(true);
          }
        })
        if (this.hasPlayerContinuePlaybackOnWindowUnloadFeature) return;
        document.addEventListener('visibilitychange', () => { this.visibilityChange(); });
      }).catch(err => this.handleInitialPlayerDataFailure(err)); // end getIntialBulbData catch
    },
    handleInitialPlayerDataFailure(error) {
      if (_.has(error, 'response.data.blueScreen')) {
        const {
          response: {
            data: {
              error: errorType,
              blueScreen,
            },
          },
        } = error;
        const errorMessage = error?.response?.data?.msg;
        if (errorType === 'vimeo_error') {
          this.constructVimeoBlueScreenError(blueScreen, errorMessage);
        }
        this.newBlueScreenRedirect(blueScreen);
      } else if (_.has(error, 'blueScreen')) {
        this.newBlueScreenRedirect((error.blueScreen))
      }
      else if (_.has(error, 'response.data.error')) {
        if (error.response.data.error === 'WarpwireAuthorizationError') {
          this.newBlueScreenRedirect({
            title: 'Cannot Access',
            subtitle: "Warpwire Authentication Error",
            icon: 'pan_tool',
            text: 'Please contact your instructor to reauthorize this video.',
          })
          // this.showWarpwireModal = true;
          // this.warpwireRedirect = error.response.data.redirectUrl;
          // this.setSnackbar({
          //   text: 'There was an error during the Warpwire authorization process. Please login again to continue. ',
          //   color: 'error',
          //   timeout: 0,
          // });
          // return;
        }
      }
      else if (error === 'rootLmbPreview') {
        this.newBlueScreenRedirect({
          title: 'Cannot Access',
          subtitle: `This ${this.termForBulb} cannot be previewed in the Player`,
          icon: 'pan_tool',
          text: `Please launch Learner Made ${this.termForBulb.capitalize()}s from from the dashboard.`,
        })
      }
      else if (error === 'missingBulbVideos') {
        this.newBlueScreenRedirect({
          title: 'Playback Error',
          subtitle: "Missing Video Sources",
          text: `We were unable to find any video sources for this ${this.termForBulb}. Please contact help@playposit.org.`,
        })
      }
      else {
        // unknown error, we should rediect to blue screen, not sure when this gets triggered
        dataLayer.errorLog(error, this.$options.name);
        console.error(error);
        this.initialBulbDataFailed();
      }
    },
    initialBulbDataFailed() {
      /**
       * Method called after the getInitialPlayerData failed three times
       */
      this.newBlueScreenRedirect({
        subtitle: `Oops! We had some trouble loading this ${this.termForBulb}.`,
        text: `Please click <a target="_blank" rel="noopener noreferrer" href="https://knowledge.playposit.com/article/216-troubleshooting-bulb-playback#generic">here</a> for troubleshooting directions. If these do not resolve the issue, reach out to help@playposit.org and include the numbers located in the top right of this screen.`,
      })
    },
    resume() {
      const resumeTime = _.get(this.bulbAttempt, 'maxDisplayTime') >= _.get(this.bulb, 'displayDuration')
        ? _.get(this.bulb, 'displayDuration') - .01
        : _.get(this.bulbAttempt, 'maxDisplayTime');
      EventBus.$emit('requestAction', {key: 'seek', seekTime: resumeTime});
      this.snackbar.enabled = false;
    },
    setBranding(branding) {
      /**
       * Use the user.branding to override the default colors of branding css variable
       */
      const styles = [] // style strings to get added to a string tag
      const css = {}; // object for cssVars plugin
      if (_.has(branding, 'activeColor') && branding.activeColor) {
        styles.push(`body{ --branding-active-hex: ${branding.activeColor}}`)
        this.$vuetify.theme.primary = branding.activeColor;
        css['branding-active-hex'] = branding.activeColor
      } else {
        css['branding-active-hex'] = '#2196F3';
      }
      if (_.has(branding, 'baseColor') && branding.baseColor) {
        styles.push(`body{ --branding-base-hex: ${branding.baseColor}}`);
        this.$vuetify.theme.secondary = branding.baseColor;
      } else {
        css['branding-base-hex'] = '#1976D2';
      }
      if (_.has(branding, 'inactiveColor') && branding.inactiveColor) {
        styles.push(`body{ --branding-inactive-hex: ${branding.inactiveColor}}`);
        css['branding-inactive-hex'] = branding.inactiveColor;
        this.$vuetify.theme.tertiary = branding.inactiveColor;
      } else {
        css['branding-inactive-hex'] = '#FFF';
      }
      // Call using defaults
      cssVars({variables: css});
      // Create and append style tag
      this.addCSS(styles)
    },
    refreshPlayerWindow() {
      store.remove('skip-panopto-authorization');
      location.reload();
    },
    redirectToPanoptoHelpArticle() {
      window.open('https://support.panopto.com/s/article/How-to-Enable-Third-Party-Cookies-in-Supported-Browsers', '_blank');
    },
    checkInternetSpeed() {
      window.open('https://fast.com', '_blank');
    },
    loadCssInjectionDirectly(cssToInject) {
      /* Inject contents of the CSS file that were already fetched during the player's initial API call. */
      const styleElement = document.createElement('style');
      styleElement.setAttribute('type', 'text/css');
      styleElement.classList.add('injected-playposit-styles');
      /* Add the text contents of the CSS file into the style element. */
      styleElement.textContent = cssToInject;
      /* Add the style element inside the document head. */
      document.getElementsByTagName('head')[0].appendChild(styleElement);
    },
    loadCssInjection(cssInjectionUrl) {
      const linkElement = document.createElement('link');

      /* Add attributes. */
      linkElement.setAttribute('rel', 'stylesheet');
      linkElement.setAttribute('href', cssInjectionUrl);
      linkElement.classList.add('injected-playposit-styles');

      /* Attach to the document head. */
      document.getElementsByTagName('head')[0].appendChild(linkElement);
    },
    setPlayerUserType() {
      // If user type is teacher - set pp_player_type and pp_instructor_token in store
      if (this.user.userType === 'teacher') {
          store.set('pp_player_type', 'instructor');
          store.set('pp_instructor_token', this.token);
          // If type = broadcast - add queryParam user = instructor
          if (this.queryParams.get('type') === 'broadcast') {
            if (!this.queryParams.get('user_type') || this.queryParams.get('user_type') !== 'instructor') {
             this.queryParams.set('user_type', 'instructor');
             history.pushState(null, null, `/player_v2?${this.queryParams.toString()}`);
            }
          }
        } else if (this.user.userType === 'student') {
          // If user type is student - set pp_learner_type and pp_learner_token in store
          store.set('pp_player_type', 'learner');
          store.set('pp_learner_token', this.token);
          // If type = broadcast - add queryParam user = learner
          if (this.queryParams.get('type') === 'broadcast') {
            if (!this.queryParams.get('user_type') || this.queryParams.get('user_type') !== 'learner') {
              this.queryParams.set('user_type', 'learner');
              history.pushState(null, null, `/player_v2?${this.queryParams.toString()}`);
            }
          }
        }
    },
    openSettingsMenu() {
			this.setSettingsMenu(true);
    },
    setStartTime(startTime) {
      if (startTime) {
        // console.log('store startTime',)
        this.setDisplayTimeStart(parseInt(startTime))
      }
    },
    setupPanoptoEvents() {
      EventBus.$on('panoptoLoginShown', this.handlePanoptoLoginShown);
      this.handlePanoptoAuthenticationFlow;
    },
    async handlePanoptoIframeClick() {
      if (this.panoptoIframeMouseOver) {
        await this.$nextTick();
        window.removeEventListener('blur', this.handlePanoptoIframeClick);
        this.setSnackbar({
          autoHeight: true,
          text: `Once you've successfully logged into Panopto, refresh this page to continue.`,
          color: 'warning',
          timeout: 0,
          action: 'panoptoRefresh'
        });
      }
    },
    /**
     * This method will be invoked IFF the login page is shown in cases where the user *needs to be authenticated*
     * before accessing the video.
     * 
     * Note: If the user is already authenticated, this will not fire.
     * 
     * @param {string} panoptoAuthIframeSrc The *passed* back Panopto iframe source authentication endpoint configured by the schools' panopto field (server).
     */
    async handlePanoptoLoginShown(panoptoAuthIframeSrc) {
      this.showPanoptoAuthIframe = true;
      await this.$nextTick();
      this.panoptoAuthIframeSrc = panoptoAuthIframeSrc;
      this.setSnackbar({
        autoHeight: true,
        text: `Panopto authorization needed in order to view this ${this.termForBulb}. Please login to your Panopto account.`,
        color: 'warning',
        timeout: 0,
        action: 'panoptoHelpArticle'
      });
      window.addEventListener('blur', this.handlePanoptoIframeClick);
    },
    async setToken() {
      /**
       * Check url parameters for user token and set vuex or store values accordingly.
       */
      // [ ] make sure to expire stored token
      // Check if there is a token in the URL first
      if (this.queryParams.get('token')) {
        this.token = this.queryParams.get('token');
        this.tokenType = 'url';
        this.queryParams.delete('token');
        history.replaceState(null, null, `/player_v2?${this.queryParams.toString()}`);
      } else if (this.queryParams.get('user_type')) {
        // Check for broadcast
        if (this.queryParams.get('user_type') === 'instructor') this.token = store.get('pp_instructor_token');
        else if (this.queryParams.get('user_type') === 'learner') this.token = store.get('pp_learner_token');
      } else if (store.get('pp_primary') === 'instructor' && this.queryParams.get('type') === 'share') {
        // Dash instructor - but possible has Player learner token from list code/PD
        this.updatePlayerStore('instructor');
      } else if (store.get('pp_player_type') === 'instructor') {
        // If store.pp_player_type is instructor check for a pp_instructor_token in store
        this.updatePlayerStore('instructor');
      } else if (store.get('pp_player_type') === 'learner') {
        // If store.pp_player_type is learner check for a pp_learner_token in store
        this.updatePlayerStore('learner');
      } else if (store.get('pp_primary') === 'instructor') {
        // pp_primary is set by Dash - set instructor token from store
        this.updatePlayerStore('instructor');
      } else if (store.get('pp_primary') === 'learner') {
        // pp_primary is set by Dash - set learner token from store
        this.updatePlayerStore('learner');
      }
      if (this.token) {
        this.setUser({token:this.token})
      }
      await PlayerService.setupAjax(this.token);
    },
    setupXAPI(data) {
      /**
       * Load default values for XAPI
       */
       // [ ] add this back in later
      return console.log('Add XAPI integration')
      if (!validateEmail(this.user.email)) {
        let suffix = (this.user.userType === 'teacher') ? '@instructor.playposit.com' : '@learner.playposit.com';
        data.user.email = `${this.user.email}${suffix}`;
      }
      if (!validateEmail(this.bulb.teachers[0].email)) {
        this.bulb.teachers[0].email = `${this.bulb.teachers[0].email}@instructor.playposit.com`;
      }
      const defaults = {
        actor: {
          name: `${this.user.firstName} ${this.user.lastName}`,
          id: this.user.id,
          email: this.user.email
        },
        instructor: {
          name: `${this.bulb.teachers[0].firstName} ${this.bulb.teachers[0].lastName}`,
          id: this.bulb.teachers[0].id,
          email: this.bulb.teachers[0].email
        },
        school: {
          // [ ] refactor to move school data to user object
          // [ ] explore why school wasn't always brought in.
          name: _.has(this.bulb.teachers[0], 'school.name') ? this.bulb.teachers[0].school.name : '',
          id: _.has(this.bulb.teachers[0], 'school.id') ? this.bulb.teachers[0].school.id : '',
        },
        // [ ] update these...
        lesson: this.bulb,
        student_lesson: this.bulbAttempt || {}
      };
      // console.log('CALIPER DEFAULTS', defaults);
      XApiService.setStatementDefaults(defaults);
      // if (this.bulb.teachers[0].school_id === 869) { // Only send Caliper events for Purdue
      //   CaliperService.setupOAuth(defaults);
      // }
      XApiService.buildBeginLessonStatement({
        activity: {
          id: `https://xapi.playposit.com/activities/video/${this.bulb.id}`,
          name: this.bulb.title,
          bulb_id: this.bulb.id
        }
      });
    },
    async retryWithStoreToken(lesson_id, student_lesson_id, section_id) {
      // [ ] removed for the time being until we can spend more time looking into this
      this.token = store.get('token').value;
      this.tokenType = 'store';
      this.$store.commit('setToken', this.token);
      await PlayerService.setupAjax(this.token);
      return this.getInitialPlayerData(lesson_id, student_lesson_id, section_id);
    },
    hasStoreTokenExpired(token) {
      // [ ] was part of logic for retryWithStoreToken
      if (!token || !token.value || !token.expiration) return true;
      return Date.now() >= token.expiration;
    },
    loadDriftWidget() {
      // If the bulb is COM101 - render Drift widget
      if ([512500,517134,517136,521626,522016,522190,522244,527519,532009,534731,534732,534733,534734,534735,534736,534737,534738,534739,534740,536303,536313,536316,536320,536321,536323,536324,536325,536327,536328,536329,536330,536331,536334,536335,536336,536337,536339,536340,536341,536342,536349,536350,536352,536353,536355,536356,536357,536358,536359].includes(this.bulb.id)) {
        drift.load('sc4b8f7p722p');
        drift.identify(`teacher-${this.user.id}`, {
          playposit_email: this.user.email,
          name: `${this.user.firstName} ${this.user.lastName}`,
          user_id: this.user.id,
          user_type: this.user.userType,
          bulb_id: this.bulb.id,
          bulbTeacher_id: this.bulb.teachers[0].id,
        });
      }
    },
    userSnackbar() {
      if (this.user.userType === 'student' && (this.user.firstName === 'FirstName' || this.user.lastName === 'LastName')) {
        // trigger listcode modal for users to enter their name
        this.showNameModal = true;
      }
      else {
        // user has name, trigger toasts to loging statu
        if (this.token && this.user.id) {
          if (this.user.userType === 'student') {
            const anon = this.user.firstName === 'User' && this.user.lastName === 'Anonymous';
            const text = (()=>{
              if (this.user.readOnly) return  `Observing submission by ${this.user.firstName} ${this.user.lastName}.`
              if((this.user.firstName === 'firstName' && this.user.lastName === 'lastName') || (this.user.firstName === 'User' && this.user.lastName === 'Anonymous')) return `Attempting as anonymous.`
              return `Attempting as ${this.user.firstName} ${this.user.lastName}.`
            })()
            this.setSnackbar({
              color: 'success',
              action: this.user.isLti || anon || this.user.readOnly || this.isPlaylist ? '' : 'change-user',
              text,
              timeout: 5000
            });
          } else {
            this.setSnackbar({
              action: 'playbackMode',
              text: `Preview Mode: Answers and progress are not saved.`,
              color: 'grey darken-3',
              timeout: 5000
            });
          }
        } else {
          this.setSnackbar({
            text: 'Preview Mode: Attempting anonymously. Answers and progress are not saved.',
            color: 'grey darken-3',
            timeout: 5000
          });
        }
      }
    },
    updateFaviconAndTitle() {
      const favicon = document.getElementById('favicon');
      if ([2421].includes(_.get(this, 'bulb.masterTeacher.school.id', []))) favicon.setAttribute('href', 'https://bunny.playposit.com/inject/appos.ico');
      else favicon.setAttribute('href', 'https://bunny.playposit.com/inject/hcme.ico');
      document.title = this.bulb.name;
    },
    updatePlayerStore(userType) {
      if (userType === 'instructor') {
        store.set('pp_player_type', 'instructor')
        const userToken = store.get('pp_instructor_token');
        if (userToken) this.token = userToken;
      } else if (userType === 'learner') {
        const userToken = store.get('pp_learner_token');
        store.set('pp_player_type', 'learner')
        if (userToken) this.token = userToken;
      }
    },
    updateUser() {
      this.user.firstName = this.newUser.firstName;
      this.user.lastName = (this.newUser.title && !this.disableUserTitle) ? `${this.newUser.lastName}, ${this.newUser.title.trim()}` : this.newUser.lastName;
      
      // ajax to updatename
      this.processingNameModal = true;
      PlayerService.updateStudent(this.user.id, this.user).then((result) => {
        // turn modal off
        this.showNameModal = false;
        this.processingNameModal = false;
        this.userSnackbar();
        if (this.isBroadcastStudent) triggerLearnerStatus(this.broadcastId, this.user.id, this.bulbAttempt.id, 'online');
      }).catch((err) => {
        this.processingNameModal = false;
        this.setSnackbar({
            text: `There was an error while update updating your user name, please try again or check your internet connection.`,
            color: 'error',
            timeout: 5000
          });
      })
    },
    visibilityChange() {
      if (document.hidden) {
        if (this.playerState === 'play') this.wasHidden = true;
        if (this.bulbInitialized && !this.isLiveSession) EventBus.$emit('requestAction', 'pause');
      } else if (this.wasHidden && !this.isLiveSession) {
        this.setSnackbar({
          text: `Are you still there? Click play to continue.`,
          color: 'warning',
          timeout: 5000
        });
        this.wasHidden = false;
      }
    },
    // nsf methods from old db scheme
    setInitialComplexity(bulbs, treatment) {
      /**
      * set the starting complexity level for the first segment
      */
      // console.log('setInitialComplexity', bulbs.length, treatment)
      if (treatment === 0) { // control
        // console.log('set control initail complexities')
        this.setSegmentComplexity({id: this.bulbs[0].id , complexity:3})
        this.setSegmentComplexity({id: this.bulbs[1].id , complexity:2})
        this.setSegmentComplexity({id: this.bulbs[2].id , complexity:3})
        this.setBulbComplexity(3);
      } else if (treatment === 1) {
        // console.log('set treatment 1 initial complexities')
        // what about student returning to this lesson?
        this.setSegmentComplexity({id: this.bulbs[0].id, complexity: 3})
        this.setBulbComplexity(3);
      } else {
        if (this.user.userType === 'student') {
          // this.setSegmentComplexity({id: this.bulb[0].id, complexity: this.adaptiveComplixityTreatment2()})
          PlayerService.getNSFScore(this.user.id, {linked_lessons:this.bulbs[0].linked_lessons}).then((res) => {
            // console.log('nsfScore result', res.data);
            if (res.data.status === 'current') { // this lesson is not finished, preload complexities from last nsf_attempt
              // console.log('set complexities from last session', _.map(res.data.attempts, 'complexity'))
              res.data.attempts.forEach((attempt, i) => {
                this.setSegmentComplexity({id: attempt.lesson_id, complexity: attempt.complexity});
                this.setBulbComplexity(attempt.complexity);
              });
            } else if (res.data.status === 'previous') { // this lesson has not been started, use complexities from last bulb to set initial complexity
              const attempt = res.data.attempts[0]
              const complexity = {1: 1, 2: 1, 3:3, 4:5, 5:5}[attempt.complexity];
              // console.log('set Initial complexity from last bulb (' + attempt.complexity + ') to ', complexity)
              this.setSegmentComplexity({id: this.bulbs[0].id, complexity});
              this.setBulbComplexity(complexity);
            } else if (res.data.status === 'first') { // user has never attempted an nsf bulb, use complexitiy 3
              // console.log('no nsf attempts, set complexity to 3')
              this.setSegmentComplexity({id: this.bulbs[0].id, complexity: 3})
              this.setBulbComplexity(3);
            }
          }).catch((err) => {
            // error grabbing previous segment complexity, default to complexity 3
            // console.log('error grabbing nsf score', err)
            this.setSegmentComplexity({id: this.bulbs[0].id, complexity: 3})
            this.setBulbComplexity(3);
          });
        } else {
          this.setSegmentComplexity({id: this.bulbs[0].id, complexity: 3})
          this.setBulbComplexity(3);
        }
      }
      this.setSegmentComplexity({id: this.bulbs[3].id, complexity: 1})
    },
    setupNSF(section_id) {
      // [ ] keeping here for refrence later
      // control: 777171
      // algo  1: 777172
      // algo  2: 777181
      if (this.bulbs[0].teacher_id === 1237770) {
        // throw bluescreen if the lesson is complete
        // console.log(this.student_lessons.length,  _.sumBy(this.student_lessons, (o) => (o.active)) === 0)
        if ( _.sumBy(this.student_lessons, (o) => (o.active)) === 0) {
          this.blueScreenRedirect({
            title: 'Cannot Retake',
            subtitle: "This lesson cannot be retaken once complete.",
            icon: 'pan_tool',
          });
        }
        const treatment = section_id ? [777171, 777172, 777181].indexOf(section_id) : Math.floor(Math.random()*3);
        this.setTreatment(treatment)
        // console.log('nsf treatment:',section_id,  treatment, ['control', 'treatment 1', 'treatment 2'][treatment]);
        const complexities = [] // for nsf adaptive lesson
        this.bulbs.forEach((lesson, l) => {
          complexities.push(_.map(lesson.streams, 'complexity'))
          if (section_id === 777171 && l !== this.bulbs.length - 1) {
            // control group and content videos
            // console.log('control group, remove questions from lesson', l)
            this.bulbs[l].questions = [];
          } else if  (section_id === 777171) {
            // remove questions with reference to quizzes from control group
            // console.log('control group, remove quizze questions', lesson.questions)
            this.bulbs[l].questions =  _.filter(lesson.questions, (q) => !q.question_data.text.includes("quiz"));
          }
        });
        // console.log('post nsf questions', _.map(this.bulbs, (l) => l.questions.length));
        this.$store.commit('setBulbs', this.bulbs);
        this.setComplexityLevels(complexities);  // nsf optional
        this.setInitialComplexity(this.bulbs, treatment)
      }
    },
    initEventListeners() {
      document.addEventListener('keyup', this.handleKeyboardTabEvent);
    },
    removeEventListeners() {
      document.removeEventListener('keyup', this.handleKeyboardTabEvent);
    },
    handleKeyboardTabEvent(event) {
      if (event.code === 'Tab') {
        if (['nav-margin', 'timeline-wrapper'].includes(event.target.offsetParent?.id)) {
          [event.target.style.outline, event.target.style.border] = [
            `3px solid ${calculateContrast(Color(this.branding.activeColor).hex())}`,
            `1px solid ${calculateContrast(Color(this.branding.activeColor).hex())}`
          ];
        } else {
          if (
            (
              event.target.classList.contains('v-btn')
              && event.target.classList.contains('primary')
            )
            || event.target.classList.contains('pp-jump')
          ) {
            event.target.style.outline = '3px solid #000';
            event.target.style.outlineOffset = '2px';
          } else {
          const backgroundColor = getInheritedBackgroundColor(event.target);
          event.target.style.outline = `3px solid ${calculateContrast(Color(backgroundColor).hex())}`;
          }
        }
        event.target.onblur = () => {
          if (event.target.style.outline) event.target.style.outline = '';
          if (event.target.style.border) event.target.style.border = '';
        };
        if (
          this.$refs.bulbControls.$refs.videoContainer.classList.contains('play')
          && this.playerControlsDisplayType.toLowerCase() === 'fade'
          ) {
            clearTimeout(this.controlsWrapperTabTimeout);
            this.$refs.bulbControls.$refs.controlsWrapper.style.setProperty('opacity', 1);
            this.controlsWrapperTabTimeout = setTimeout(() => {
              this.$refs.bulbControls.$refs.controlsWrapper.style.setProperty('opacity', 0);
            }, 3500);
        }
      }
    },
    constructVimeoBlueScreenError(
      blueScreen = {},
      errorMessage = null
    ) {
      let additionalReason = ``;
      if (errorMessage) {
        additionalReason = `
          <li>${errorMessage}</li>
        `;
      }
      blueScreen.subtitle = `Sorry, we couldn't find that page`;
      blueScreen.text = `
      <h3 style="font-style: italic; margin-top: -27px;">Reasons you might be seeing this page:</h3>
      <ul style="display: grid; grid-gap: 14px; margin: -25px 0;">
        <li>The Vimeo video is private. You may have to change it's <a target="_blank" rel="noopener noreferrer" href="https://vimeo.zendesk.com/hc/en-us/articles/224817847-Manage-your-video-s-privacy-settings">privacy settings.</a></li>
        <li>It exists, but you don't have permission to see it.</li>
        ${additionalReason}
      </ul>
      `;
    },
    setupWindowObjectDebugging() {
      if (window.btoa) {
        const encrypted = window.btoa(process.env.VUE_APP_DEVELOPER_CODE);
        window.vm = (key) => {
          if (window.btoa(key) === encrypted) {
            return {
              vm: this,
              debug: {
                invokeFailedStreamsBluescreen: () => {
                  this.newBlueScreenRedirect({
                    title: 'Failed Streams',
                    subtitle: `All streams for this ${this.termForBulb} segment failed to load.`,
                    code: '511',
                    text: `Please click <a target="_blank" rel="noopener noreferrer" href="https://knowledge.playposit.com/article/216-troubleshooting-bulb-playback#generic">here</a> for troubleshooting directions. If these do not resolve the issue, reach out to help@playposit.org and include the numbers located in the top right of this screen.`,
                  });
                },
                invokeMissingStreamsBluescreen: () => {
                  this.newBlueScreenRedirect({
                    title: 'Missing Streams',
                    subtitle: `There are no available streams for ${this.termForBulbArticle} ${this.termForBulb} segment.`,
                    text: `Please click <a target="_blank" rel="noopener noreferrer" href="https://knowledge.playposit.com/article/216-troubleshooting-bulb-playback#generic">here</a> for troubleshooting directions. If these do not resolve the issue, reach out to help@playposit.org and include the numbers located in the top right of this screen.`,
                    location: `Player.vue:: debugging bluescreen logic.`,
                  });
                },
                invokeUnknownErrorBluescreen: () => {
                  this.initialBulbDataFailed();
                },
              }
            };
          }
          return console.warn('The developer code you supplied is incorrect.');
        };
      } else {
        window.vm = () => {
          console.warn('This browser does not support the "window.btoa" encryption function.');
        };
      }
    },
    setThirdPartyCookieValue(value) {
      this.setThirdPartyCookiesEnabled(value);
    },
    determineResourceLinkId() {
      if (this?.queryParams?.get('resource_link_id')) return this.queryParams.get('resource_link_id');
      if (
        (
          this?.queryParams?.get('playlist') === 'true'
          || this?.queryParams?.get('playlist') === '1'
        )
        && this?.queryParams?.get('playlistResourceLinkId')
      ) {
        return this?.queryParams?.get('playlistResourceLinkId');
      }

      return null;
    },
  },
  watch: {
    async 'loaded'() {
      if (this.loaded) {
        this.loadDriftWidget();
        setTimeout(() => {
          if (!this.bulbInitialized && !this.videosPrepped) {
            if (this.snackbar.color === 'error') {
              this.snackbar.enabled  = true
            }
            else {
              if (this.panoptoEmbedInitializationError) return;   
              this.triggerFallbackStream();
            }
          }
        }, 60000);
      }
      if (
        _.get(this.section, 'key[0]', '') === 'g'
        && this.bulbAttempt.id !== 0
        && _.get(this.section, 'bulbSection.courseWorkId')
        && !_.get(this.bulbAttempt, 'data')
        && this.schoolId
      ) {
        const { data: studentSubmissionId } = await PlayerService.fetchGoogleStudentSubmissionId({
          courseWorkId: _.get(this.section, 'bulbSection.courseWorkId'),
          courseId: _.get(this.section, 'key', '').substring(1),
          bulbAttemptId: this.bulbAttempt.id,
        })
        if (studentSubmissionId) this.setStudentSubmissionId(studentSubmissionId);
      }
    },
    async showNameModal(newValue, oldValue) {
      await this.$nextTick();
      if (newValue) {
        this?.$refs?.showNameModal?.$el?.classList?.remove('remove-onfocus-show-name-modal-embedded');
      }
    },
  },
  async created() {
    window.preventBrokenPageLinkFromDisplaying = true;
    this.setQueryParams(new URLSearchParams(window.location.search))
    this.setStartTime(this.queryParams.get('time'));
    this.setLmsLaunch(this.queryParams.get('lms_launch'));
    this.setLti13Launch(this?.queryParams?.get('lti13Launch'));
    this.setLMSIssuer(this?.queryParams?.get('issuer'));
    await this.setToken();
    this.getInitialBulbData();
  },
  mounted() {
    this.setUserAgent(new parser.UAParser().getResult());
    this.initEventListeners();
    this.setupWindowObjectDebugging();
    if (this.queryParams.get('pd')) {
      this.setBulbIsPD();
      this.queryParams.delete('pd');
      history.replaceState(null, null, `/player_v2?${this.queryParams.toString()}`);
    }
    this.$checkCookie(this.hostedIframeSource, this.setThirdPartyCookieValue.bind(this));
  },
  beforeDestroy() {
    this.removeEventListeners();
  }
};
</script>


<style lang="scss">
html, body {
  margin:0;
  padding:0;
  overflow:hidden;
  height:100%;
   /* default branding color to blue */
  /*--branding-active-hex: #2196F3;*/
   /* used for the background of pulsing quesitons */
  /*--branding-base-hex: #1976D2;*/
    /* used mostly for icon text */
  /*--branding-inactive-hex: #FFF;*/
}

/* suppress focus ring on form controls for mouse users */
[data-whatintent='mouse'] *:focus {
  outline: none;
}

[data-whatintent='keyboard'] *:focus {
  animation: pulse-alert 1s infinite;
}

.branding-active {
  /* Generate a class for setting the background to blue based on branding primary color */
  background-color: var(--branding-active-hex) !important;
}
.branding-active-text,.branding-active--text {
  color: var(--branding-active-hex) !important;
}
.branding-active-border {
  border-color: var(--branding-active-hex) !important;
}
.branding-base {
  background-color: var(--branding-base-hex) !important;
}
.branding-base-text {
  color: var(--branding-base-hex) !important;
}
.branding-inactive {
  background-color: var(--branding-inactive-hex) !important;
}
.branding-inactive-text {
  color: var(--branding-inactive-hex) !important;
}

.v-btn.branding-active:not(.btn--outline):not(.btn--disabled) {
  color: var(--branding-inactive-hex) !important;
}

.ppcaption.active-caption {
  border-color: var(--branding-active-hex) !important;
}

.v-btn.v-btn--outline.v-btn--depressed.error {
  color: #ff5252 !important;
}

body .primary {
  background-color: var(--branding-active-hex) !important;
  border-color: var(--branding-active-hex) !important;
}

body .secondary {
  background-color: var(--branding-base-hex) !important;
  border-color: var(--branding-base-hex) !important;
}

body .primary--text{
  color: var(--branding-active-hex) !important;
}
body .primary--text input, body .primary--text textarea {
  caret-color: var(--branding-active-hex) !important;
}

/* IE 11 css vars polyfill requires css vars to be defined here, so IE*/
.v-tabs__slider.accent {
  background-color: var(--branding-active-hex) !important;
}
.noUi-connect:nth-child(1) {
	/* 0 to display_time */
	background-color: var(--branding-active-hex) !important;
	background-color: #0000FF;
}

.snackbar-actions {
  display: flex;
  justify-content: flex-end;

}

.snackbar-actions .btn {
  padding: 2.5px 5px;
  margin-top: 0;
  margin-bottom: 0;
}

.snackbar-actions .v-btn.close {
  margin-left: 24px;
}

.snack__content {
  height: auto;
  flex-direction: column;
}

#posit-embed-wrapper{
  position:fixed;
  overflow:hidden;
  width:100%;
  height:100%;
}
#sidenav-overlay,.drag-target { display: none !important; }
.sm-margin{
  margin-top:10px;
  margin-bottom:10px;
}

.full-width {
  width: 100%;
}

.player-loader {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.player-loader h1 {
  font-weight: lighter;
  color: #2196f3;
}

.row-pad{
  padding:10px 0;
}

.sm-pad{
  padding:10px 0;
}


.muted {
  color: rgba(0,0,0,0.54);
}

.spinner{
  display:none !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.v-tooltip__content {
  opacity: 1 !important;
}

.tooltip__content.menuable__content__active {
  z-index: 10000 !important;
}

.full-height {
  height: 100%;
}


.screen-reader-tag {
  position: absolute;
  left: -9999999px;
  user-select: none;
}

.panel-warning {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #757575 !important;
}

.panel-warning i {
  margin-bottom: 15px;
}
/* is there a way to pass id to the tutorial dialog*/
.tutorial.v-dialog {
 height: 100%;
 max-height: 40vw !important;
 overflow-y: hidden;
}
.v-dialog iframe {
  border: none;
}

.v-dialog .thumbnail {
  width: 100%;
  /*height: 40px;*/
  /*width: auto;*/
  /*max-width: 60px;*/
}
.v-dialog .thumbnail-wrapper {
  position: relative;
  height: 100%;
  cursor: pointer;
  background-size: cover;
  background-position: center;
}

.v-dialog .thumbnail-wrapper-nonselect {
  position: relative;
  height: 100%;
  background-size: cover;
  background-position: center;
}
.copy-bulb {
  max-width: 800px;
}
.copy-bulb h3{
  font-weight: 400;
}

.v-chip.leading-button-chip .v-chip__content {
  padding-left: 4px !important;
}

.v-chip.leading-button-chip .v-chip__content .leading {
  margin-left: 2px;
}

.v-chip.no-focus-chip:focus {
  box-shadow: none !important;
}

.v-chip.no-focus-chip:focus:after {
  display: none;
}

.v-chip.pointer .v-chip__content {
  cursor: pointer;
}

.custom-select {
  /* styling for bootstrap select in settings menu */
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  /*background: url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e) no-repeat right 0.75rem center/8px 10px;*/
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none;
}

#drift-widget-container {
  z-index:5 !important;
}

#drift-widget-container .drift-widget-welcome-online {
  bottom: 50px !important;
  right: 0px !important;
}

#drift-widget-container .drift-widget-welcome-away {
  bottom: 50px !important;
  right: 0px !important;
}

#drift-widget-container .drift-widget-welcome-expanded-online {
  bottom: 50px !important;
  right: 0px !important;
}

#drift-widget-container .drift-widget-welcome-expanded-away {
  bottom: 50px !important;
  right: 0px !important;
}

.authentication-iframe-wrapper {
  width:100%;
  padding:0;
  border:0;
  height:100%;
  position: fixed;

  &.panopto {
    background: black;
  }

  iframe {
    height: 100%;
    width: 100%;
    padding: 0;
    border: -0;
  }
}

.panopto-video-issue-iframe-container, .vimeo-video-issue-div-container {
  height: 100%;
  width: 100%;
  position: absolute;
  padding: 0;
  top: 0;
  left: 0;
  padding: 0;
  border: -0;
  z-index: 1;
}

@keyframes pulse-alert {
  0% { box-shadow: 0 0 0 0 rgba(253,151,39, 0.7); }
  70% { box-shadow: 0 0 0 17px rgba(26, 158, 145, 0); }
  100% { box-shadow: 0 0 0 0 rgba(26, 158, 145, 0); }
}

// Common styling for our toast
@import '@mixins/Toast/styles.scss';

// All the necessary styling for our zoom-broadcast bulb config class
.zoom-broadcast #sidebar-panel {
	width: calc(100% - 55px) !important;
	max-width: 100% !important;
}

.zoom-broadcast #nav-margin {
	display: block !important;
}

.zoom-broadcast #toggle-sidebar {
	display: none;
}

.zoom-broadcast #sidebar-actions li:last-child {
	display: none;
}

.zoom-broadcast #resize-side-panel {
	display: none !important;
}

.zoom-broadcast #mimic-broadcast-teacher {
	display: none !important;
}

.zoom-broadcast .sidebar-tabs {
	padding-top: 20px;
}
// end of custom zoom-broadcast styling

.remove-onfocus-show-name-modal-embedded {
  display: none !important;
}

</style>